import React from 'react';
import clsx from 'clsx';
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/16/solid';

export function Chevron(props: { open: boolean; name: string; onClick: () => void }) {
  return (
    <button
      type="button"
      aria-expanded={props.open}
      aria-label={`${props.open ? 'Collapse' : 'Expand'} ${props.name}`}
      onClick={props.onClick}
      className="-m-1 grid size-6 flex-none place-items-center rounded-md text-neutral-600 hover:bg-neutral-950/5 dark:text-neutral-300 dark:hover:bg-white/5"
    >
      {props.open ? (
        <ChevronDownIcon className="size-4" />
      ) : (
        <ChevronRightIcon className="size-4" />
      )}
    </button>
  );
}

/**
 * A list item's or a nested block's card: a grey header that opens and closes it.
 * `within` names the card holding it, so two premises' "Subject Building" cards are
 * told apart by name.
 */
export function CardFrame(props: {
  title: string;
  within?: string;
  open: boolean;
  onToggle: () => void;
  notes?: (string | null | undefined)[];
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div
      className={clsx(
        'mx-2.5 mb-2 overflow-hidden rounded-lg border border-neutral-950/[.08] dark:border-white/10',
        props.className
      )}
    >
      <div
        className={clsx(
          'flex items-start gap-2.5 bg-neutral-50 px-3 py-2.5 dark:bg-neutral-900',
          props.open && 'border-b border-neutral-950/5 dark:border-white/5'
        )}
      >
        <Chevron
          open={props.open}
          name={props.within ? `${props.title} in ${props.within}` : props.title}
          onClick={props.onToggle}
        />
        <span className="flex min-w-0 flex-col">
          <span className="break-words text-[13px] font-semibold text-neutral-950 dark:text-white">
            {props.title}
          </span>
          {props.notes?.filter(Boolean).map((note) => (
            <span key={note} className="text-xs text-neutral-500 dark:text-neutral-400">
              {note}
            </span>
          ))}
        </span>
      </div>
      {props.open && props.children}
    </div>
  );
}
